export default "__VITE_ASSET__1c17507a__"